import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-623ac05f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-calendar-times me-2" }, null, -1))
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-calendar me-2" }),
  /*#__PURE__*/_createTextVNode("วันที่สิ้นสุดโครงการ:")
], -1))
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-list me-2" }),
  /*#__PURE__*/_createTextVNode("หมายเหตุ:")
], -1))
const _hoisted_8 = { class: "text-muted" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-star me-2" }),
  /*#__PURE__*/_createTextVNode("สถานะ:")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseOffcanvasComponent = _resolveComponent("BaseOffcanvasComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createBlock(_component_BaseOffcanvasComponent, {
    ref: "endDateOffcanvas",
    placement: "right"
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode("วันที่สิ้นสุดโครงการ ")
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.endDates, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "card mb-3"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.thaiDate(item.endDate)), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("p", _hoisted_8, null, 512), [
                [_directive_dompurify_html, item.remark ? item.remark : '-']
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_9,
              _createElementVNode("p", {
                class: _normalizeClass(["mb-0", {'text-success': item.status, 'text-danger': !item.status}])
              }, _toDisplayString(item.status ? 'ปกติ' : 'ยกเลิก'), 3)
            ])
          ])
        ]))
      }), 128))
    ]),
    _: 1
  }, 512))
}